import { render, staticRenderFns } from "./HealthNav.vue?vue&type=template&id=86774e38&scoped=true"
import script from "./HealthNav.vue?vue&type=script&lang=js"
export * from "./HealthNav.vue?vue&type=script&lang=js"
import style0 from "./HealthNav.vue?vue&type=style&index=0&id=86774e38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86774e38",
  null
  
)

export default component.exports